module.exports = __webpack_public_path__ + "img/man-with-features.34d41b62.png";